

















































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import imageVideoUploader from "@/components/imageVideoUploader.vue";
import {
  commentSubmitApi,
  lessonCommentDetailApi,
} from "@/api/classroomComment";
import { __video_metadata_thumbnails__ } from "@/utils/video-metadata-thumbnails.iife.js";

@Component({
  name: "comment",
  components: {
    imageVideoUploader,
  },
})
export default class extends Vue {
  mainData: any = {
    class_situation: "",
    resource: [],
  };
  lesson_star: any = {
    A: 0,
    B: 0,
    C: 0,
    D: 0,
    E: 0,
  };
  tableData = []; // 练习明细列表
  viewImagePromotionUrl: any = "";
  uploadStatus: number = 100;
  lesson_comment_task: boolean = true; // 积分控制 - 课堂点评积分
  receiveResource: boolean = false;
  currentImageScale: boolean = true;
  currentVideoScale: boolean = true;
  uploadSuccess: boolean = true;

  created() {
    // if (this.$route.query.status !== "comment") {
    //   this.getLessonCommentDetail();
    // }
    this.getLessonCommentDetail();
  }

  solveSearchInfo(option?: any) {
    let params = { ...option };
    let errorMessage = "";
    params.lesson_star = {};
    params.lesson_comment_student_id = Number(
      this.$route.query.comment_student_id
    );
    params.comment_id = Number(this.$route.query.comment_id);
    params.student_id = Number(this.$route.query.student_id);
    params.comment_time = Number(String(Date.now() / 1000).slice(0, 10));
    if (this.lesson_star.A > 0) {
      params.lesson_star.A = this.lesson_star.A;
    } else {
      errorMessage = "课堂表现评分不能为空";
    }

    if (this.lesson_star.B > 0) {
      params.lesson_star.B = this.lesson_star.B;
    } else {
      errorMessage = "作业情况评分不能为空";
    }
    if (this.lesson_star.C > 0) {
      params.lesson_star.C = this.lesson_star.C;
    } else {
      errorMessage = "知识掌握评分不能为空";
    }
    if (this.lesson_star.D > 0) {
      params.lesson_star.D = this.lesson_star.D;
    } else {
      errorMessage = "技巧掌握评分不能为空";
    }
    if (this.lesson_star.E > 0) {
      params.lesson_star.E = this.lesson_star.E;
    } else {
      errorMessage = "综合评价评分不能为空";
    }
    if (this.mainData.class_situation) {
      params.class_situation = this.mainData.class_situation;
    } else {
      errorMessage = "上课情况不能为空";
    }
    if (this.mainData.resource && this.mainData.resource.length > 0) {
      params.resource = [];
      this.mainData.resource.forEach((item: any) => {
        params.resource.push({
          url: this.delPreDomain(item.url),
          type: item.type,
        });
      });
    } else {
      errorMessage = "上传课堂图片/视频不能为空";
    }
    return { params, errorMessage };
  }
  handleSubmit() {
    if (this.uploadStatus !== 100) {
      this.$message({
        message: "资源上传中",
        type: "warning",
      });
      return false;
    }
    if (!this.uploadSuccess) {
      this.$message({
        message: "资源获取中",
        type: "warning",
      });
      return false;
    }
    let option = this.solveSearchInfo();
    if (option.errorMessage) {
      this.$message({
        type: "error",
        message: option.errorMessage,
      });
      return false;
    }
    option.params.is_commit = true; // 提交
    commentSubmitApi(option.params).then((res: any) => {
      if (res.error_code === 0) {
        this.$message({
          type: "success",
          message: "提交成功",
        });
        this.goBack();
      } else {
        this.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  handleCancel() {
    if (this.uploadStatus !== 100) {
      this.$message({
        message: "资源上传中",
        type: "warning",
      });
      return false;
    }
    let option = this.solveSearchInfo();

    option.params.is_commit = false; // 暂存
    commentSubmitApi(option.params).then((res: any) => {});
    window.location.reload();
    this.$router.go(-1);
  }
  // 获取详细
  getLessonCommentDetail() {
    lessonCommentDetailApi({
      comment_student_id: Number(this.$route.query.comment_student_id),
    }).then((res: any) => {
      this.lesson_star = res.data.lesson_star;
      this.mainData = res.data;
      // 预览赋初值，否则点击第一次没反应
      if (res.data.resource && res.data.resource.length > 0) {
        this.viewImagePromotionUrl = res.data.resource[0].url;
      } else {
        this.mainData.resource = [];
      }
    });
  }
  // 压缩图片，接收一个文件对象、压缩比例和回调函数作为参数
  compressImage(file: any, quality: any, callback: any) {
    const reader = new FileReader(); // 使用 FileReader 对象读取文件数据
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image(); // 创建一个 Image 对象，并将图片绘制到 Canvas 上
      img.src = (event.target as any).result;
      img.onload = () => {
        let canvas: any = document.createElement("canvas");
        let ctx: any = canvas.getContext("2d");
        canvas.width = img.width;
        canvas.height = img.height;
        // console.log(canvas.width, canvas.height);
        if (canvas.width < 750) {
          this.$message({
            message: "请上传宽度大于等于 750 尺寸的图片",
            type: "error",
          });
          this.currentImageScale = false;
          return false;
        } else {
          this.currentImageScale = true;
        }
        ctx.drawImage(img, 0, 0, img.width, img.height);
        //然后使用 toBlob() 方法将 Canvas 上的图像数据转换成 Blob 对象
        canvas.toBlob(
          (blob: any) => {
            callback(blob); // 回调函数处理压缩后的数据。
          },
          file.type,
          quality
        );
      };
    };
  }
  // 拿到 file 对象，检测图片和视频的宽高是否符合限制
  mediaCheck(e: any) {
    this.uploadSuccess = false;
    // console.log(e);
    let type = e.file.type;
    if (type.includes("image")) {
      this.compressImage(e.file, 0.5, (blob: any) => {
        const url = URL.createObjectURL(blob);
        const img = document.createElement("img");
        img.src = url;
        // document.body.appendChild(img);
      });
    }
    if (type.includes("video")) {
      __video_metadata_thumbnails__
        .getMetadata(e.file)
        .then((metadata: any) => {
          // console.log("素材信息", metadata);
          let scale = (metadata.width / metadata.height).toFixed(3);
          let res = this.handleWatchScale(scale);
          // 视频又不做限制了
          // if (!res) {
          //   this.$message({
          //     message: "请上传 16:9 比例的视频",
          //     type: "error",
          //   });
          //   this.currentVideoScale = false;
          // } else {
          //   this.currentVideoScale = true;
          // }
        });
    }
    return true;
  }
  // 满足条件，开始正式上传
  handleSelected(e: any) {
    if (!this.currentImageScale) return; // 图片大小不对
    // 视频又不做限制了
    // if (!this.currentVideoScale) return; // 视频比例不对
    e.start();
  }
  handleListen(evt: any) {
    this.uploadStatus = evt;
  }
  handleImageUploader(evt: any) {
    // 处理视频回传时的空白间隔
    this.receiveResource = !this.receiveResource;
    if (evt.type === 1) {
      this.viewImagePromotionUrl = evt.url;
      this.handleResourceList(evt);
    } else if (evt.type === 2) {
      this.handleResourceList(evt);
    }
  }

  handleResourceList(data?: any) {
    if (data) {
      this.mainData.resource.push({
        url: data.url,
        type: data.type,
      });
    }
    this.$message({
      message: "上传成功",
      type: "success",
    });
    this.uploadSuccess = true;
  }
  // 去域名前缀
  delPreDomain(url: any) {
    if (url) {
      let ret = url.split("/");
      return ret[ret.length - 1];
    }
  }
  // 图片或视频比例
  handleWatchScale(scale: any) {
    if (scale.startsWith("1.77")) {
      this.uploadStatus = 100;
      return true;
    } else {
      return false;
    }
  }
  handleImageClear(...rest: any) {
    this.mainData.resource.splice(rest[0], 1);
    // this.handleResourceList();
    this.$message({
      type: "success",
      message: "删除成功",
    });
  }
  handlePreviewImagePromotion(item: any) {
    // 新窗口打开
    // window.open(item.url, "_blank");
    // 当前页面打开
    this.viewImagePromotionUrl = item.url;
    const elImagePromotion: any = document.querySelector("#elImagePromotion");
    if (elImagePromotion) {
      elImagePromotion.click();
    }
  }
  goBack() {
    if (this.uploadStatus !== 100) {
      this.$message({
        message: "资源上传中",
        type: "warning",
      });
      return false;
    }
    let option = this.solveSearchInfo();
    option.params.is_commit = false; // 暂存
    commentSubmitApi(option.params).then((res: any) => {});
    if (this.$route.query.from && this.$route.query.from === "commentInfo") {
      this.$router.push({
        name: "classroomComment",
        query: {
          from: this.$route.query.from ? this.$route.query.from : "",
          page: this.$route.query.page,
        },
      });
    } else {
      this.$router.go(-1);
    }
  }
}
